export const EN = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="24"
    viewBox="0 0 32 24"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9104_10912)">
      <path d="M0 0H32V24H0V0Z" fill="#012169" />
      <path
        d="M3.75 0L15.95 9.05L28.1 0H32V3.1L20 12.05L32 20.95V24H28L16 15.05L4.05 24H0V21L11.95 12.1L0 3.2V0H3.75Z"
        fill="white"
      />
      <path
        d="M21.2 14.05L32 22V24L18.45 14.05H21.2ZM12 15.05L12.3 16.8L2.7 24H0L12 15.05ZM32 0V0.15L19.55 9.55L19.65 7.35L29.5 0H32ZM0 0L11.95 8.8H8.95L0 2.1V0Z"
        fill="#C8102E"
      />
      <path d="M12.05 0V24H20.05V0H12.05ZM0 8V16H32V8H0Z" fill="white" />
      <path
        d="M0 9.65V14.45H32V9.65H0ZM13.65 0V24H18.45V0H13.65Z"
        fill="#C8102E"
      />
    </g>
    <defs>
      <clipPath id="clip0_9104_10912">
        <rect fill="white" height="24" width="32" />
      </clipPath>
    </defs>
  </svg>
)
